function swiperSlider() {
  const swiperContainers = document.querySelectorAll('[id^="section-id-"] .swiper-container'); 

  swiperContainers.forEach((swiperContainer) => {
    const slides = swiperContainer.querySelectorAll('.swiper-slide');

    if (slides.length === 0) {
      swiperContainer.style.display = 'none';
      return;
    }

    // ✅ destroy old swiper
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    let slidesPerView = 4;

    if (window.innerWidth < 480) slidesPerView = 2;
    else if (window.innerWidth < 767) slidesPerView = 2;
    else if (window.innerWidth < 1025) slidesPerView = 3;

    const wrapper = swiperContainer.closest('.tab-pane');

    const nextBtn = wrapper.querySelector('.custom-swiper-button-next-tab');
    const prevBtn = wrapper.querySelector('.custom-swiper-button-prev-tab');

    const enableNavigation = slides.length > slidesPerView;

    new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 16,
      loop: true,

      navigation: enableNavigation
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
          }
        : false,

      breakpoints: {
        0: {
          slidesPerView: 2.3,
          spaceBetween: 0,
          // ❌ removed grid
          pagination: false
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
          // ❌ removed grid
         pagination: false
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1025: {
          slidesPerView: 4.7,
        },
        1440: {
          slidesPerView: 4.5,
        },
      },
    });

    if (!enableNavigation) {
      nextBtn?.classList.add('hidden');
      prevBtn?.classList.add('hidden');
    }
  });
}

   function tabInitSection() {
    // Select all instances of the section on the page
    const sections = document.querySelectorAll('[id^="section-id-"]');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll('.tab-nav a');
      const panes = section.querySelectorAll('.tab-pane');

      // Remove any existing event listeners to prevent duplication
      tabs.forEach((tab) => {
        tab.removeEventListener('click', handleTabClick);
        tab.addEventListener('click', handleTabClick);  
      });

      function handleTabClick(event) {
        event.preventDefault();

        // Clear active classes in the current section
        tabs.forEach((t) => t.classList.remove('active'));
        panes.forEach((p) => p.classList.remove('active'));

        // Activate clicked tab
        const targetPaneId = this.getAttribute('href');
        const targetPane = section.querySelector(targetPaneId);

        if (targetPane) {
          this.classList.add('active');
          targetPane.classList.add('active');
        }

        setTimeout(() => {
  const swiper = targetPane.querySelector('.swiper-container')?.swiper;
  if (swiper) swiper.update();
}, 100);
      }

      // Activate the first tab by default
      if (tabs.length > 0) {
        tabs[0].click();
      }
    });
  }





    document.addEventListener('DOMContentLoaded', function (event) {
      tabInitSection();
      swiperSlider();
    });
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:unload', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:select', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:block:select', function (event) {
        tabInitSection();
        swiperSlider();
      });
      document.addEventListener('shopify:block:deselect', function (event) {
        tabInitSection();
        swiperSlider();
      });
    }

 